import React, { createContext, useState } from "react";

export const AdminContext = createContext({});

const AdminProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [myRole, setMyRole] = useState(null);


  return (
    <AdminContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        myRole, setMyRole,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export default AdminProvider;
